<template>
  <div class="admin-selector">
    <label class="form-label">
      <slot name="label">{{ label }}</slot>
    </label>

    <div class="position-relative">
      <input
        type="text"
        class="form-control"
        :placeholder="placeholder"
        :value="searchTerm"
        @input="$emit('update:search-term', $event.target.value)"
        @focus="$emit('focus-input')"
      >

      <div
        v-if="showDropdown && searchResults.length > 0"
        class="position-absolute w-100 mt-1 bg-white border rounded shadow-sm admin-search-results"
      >
        <div
          v-for="admin in searchResults"
          :key="admin.id"
          class="p-2 admin-option d-flex justify-content-between align-items-center"
          @click="$emit('select-admin', admin)"
        >
          <div>
            <div class="fw-semibold">{{ admin.name }}</div>
            <small class="text-muted">{{ admin.email }}</small>
          </div>
          <button type="button" class="btn btn-sm btn-outline-primary" tabindex="-1">
            <i class="bi bi-plus"></i>
          </button>
        </div>
      </div>

      <div
        v-if="loading"
        class="position-absolute w-100 mt-1 bg-white border rounded shadow-sm p-2 admin-loading"
      >
        <div class="text-center">
          <div class="spinner-border spinner-border-sm" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
          Loading admins...
        </div>
      </div>
    </div>

    <div v-if="existingAdmins.length > 0" class="mt-2">
      <small class="text-muted d-block mb-1">{{ existingAdminsTitle }}</small>
      <ul class="list-group list-group-flush border rounded">
        <li
          v-for="admin in existingAdmins"
          :key="admin.id"
          class="list-group-item py-2 d-flex justify-content-between align-items-center"
        >
          <div>
            <div class="fw-semibold">{{ admin.name }}</div>
            <small class="text-muted">{{ admin.email }}</small>
          </div>
          <button
            type="button"
            class="btn btn-sm btn-outline-danger"
            @click="$emit('remove-admin', admin)"
            title="Remove admin"
            tabindex="-1"
          >
            <i class="bi bi-trash"></i>
          </button>
        </li>
      </ul>
    </div>

    <small v-if="helpText" class="text-muted">{{ helpText }}</small>
  </div>
</template>

<script>
export default {
  name: 'AdminSelector',
  props: {
    label: {
      type: String,
      default: 'Select Admin'
    },
    placeholder: {
      type: String,
      default: 'Search admins...'
    },
    searchTerm: {
      type: String,
      default: ''
    },
    searchResults: {
      type: Array,
      default: () => []
    },
    showDropdown: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    selectedAdmin: {
      type: Object,
      default: null
    },
    existingAdmins: {
      type: Array,
      default: () => []
    },
    existingAdminsTitle: {
      type: String,
      default: 'Existing admins'
    },
    helpText: {
      type: String,
      default: ''
    }
  },
  emits: ['update:search-term', 'focus-input', 'select-admin', 'clear-selected', 'remove-admin']
}
</script>

<style scoped>
.admin-search-results {
  z-index: 1000;
  max-height: 200px;
  overflow-y: auto;
}

.admin-option {
  cursor: pointer;
}

.admin-option:hover {
  background-color: #f8f9fa;
}

.admin-loading {
  z-index: 1001;
}
</style>
